import { ComponentProps } from "react";
import PodcastsKeywordsDetailsCard from "@pages/Section/layouts/PodcastsPage/components/PodcastsKeywordsSectionStories/PodcastsKeywordsDetailsCard";
import PodcastsSectionStoriesCard from "@pages/Section/layouts/PodcastsPage/components/PodcastsKeywordsSectionStories/PodcastsSectionStoriesCard";
import { PodcastKeywordData } from "@pages/Section/layouts/PodcastsPage/utils/types";
import Card from "@particles/card/Card";
import { cn } from "@util/helpers";

type PodcastsKeywordStoriesProps = {
  /** The props for each podcast story card */
  cardProps: ComponentProps<typeof Card>[];
  /** Details about the podcast keyword */
  details: PodcastKeywordData;
};

/**
 * Podcasts Keywords Stories Component including Details Card and Story Cards
 */
const PodcastsSectionStories = ({
  cardProps,
  details,
}: PodcastsKeywordStoriesProps): React.ReactElement => {
  if (cardProps.length === 0) return <></>;

  return (
    <div
      data-testid="podcasts-keywords-stories-component"
      className="mb-10 border-t border-gray-850 pt-4"
    >
      <PodcastsKeywordsDetailsCard details={details} />

      {cardProps.map(
        ({ id, title, link, partnership, updatedTime, displayPaywall }) => (
          <PodcastsSectionStoriesCard
            className={cn(
              "relative my-8",
              "before:absolute before:-bottom-4 before:h-[1px] before:w-full before:bg-gray-175 last:before:hidden"
            )}
            key={`${details.id}-${id}`}
            titleProps={{
              title: title,
              to: link,
              articleId: id.toString(),
            }}
            partenrshipProps={{
              partnership: partnership,
            }}
            timeProps={{
              updated: updatedTime || "",
            }}
            displayPaywall={displayPaywall}
          />
        )
      )}
    </div>
  );
};

export default PodcastsSectionStories;
